import { useTranslations } from "use-intl";

/**
 * Infographic: a one-way relocation — a vehicle travelling along a route from a
 * pick-up location (A) to a drop-off location (B).
 */
export function RelocationGraphic() {
  const t = useTranslations("relocation.relocationEmpty");

  const lineY = 70;
  const ax = 80;
  const bx = 440;
  const mid = (ax + bx) / 2;

  return (
    <div className="rounded-xl bg-gray-50 p-4">
      <svg
        viewBox="0 0 520 150"
        className="w-full"
        role="img"
        aria-label={t("subtitle")}
      >
        {/* Route line */}
        <line
          x1={ax + 22}
          y1={lineY}
          x2={bx - 22}
          y2={lineY}
          stroke="#10b981"
          strokeWidth={2}
          strokeDasharray="6 5"
          strokeLinecap="round"
        />

        {/* Vehicle travelling the route */}
        <g>
          <rect
            x={mid - 30}
            y={lineY - 8}
            width={60}
            height={16}
            rx={6}
            fill="#059669"
          />
          <path
            d={`M ${mid - 16} ${lineY - 8} q 4 -10 16 -10 h 6 q 8 0 12 10 z`}
            fill="#10b981"
          />
          <circle cx={mid - 16} cy={lineY + 10} r={4.5} fill="#065f46" />
          <circle cx={mid + 16} cy={lineY + 10} r={4.5} fill="#065f46" />
        </g>

        {/* Pick-up pin (A) */}
        <LocationPin cx={ax} cy={lineY} label="A" />
        {/* Drop-off pin (B) */}
        <LocationPin cx={bx} cy={lineY} label="B" />

        {/* Route badge above the vehicle */}
        <g>
          <rect
            x={mid - 44}
            y={14}
            width={88}
            height={26}
            rx={13}
            fill="#10b981"
          />
          <text
            x={mid}
            y={31}
            textAnchor="middle"
            fontSize={13}
            fontWeight={600}
            fill="#ffffff"
          >
            {t("graphicRouteLabel")}
          </text>
          <path
            d={`M ${mid - 6} 40 L ${mid + 6} 40 L ${mid} 48 z`}
            fill="#10b981"
          />
        </g>

        {/* Captions */}
        <text
          x={ax}
          y={lineY + 50}
          textAnchor="middle"
          fontSize={11}
          fontWeight={600}
          fill="#059669"
        >
          {t("graphicFromLabel")}
        </text>
        <text
          x={bx}
          y={lineY + 50}
          textAnchor="middle"
          fontSize={11}
          fontWeight={600}
          fill="#059669"
        >
          {t("graphicToLabel")}
        </text>
      </svg>
    </div>
  );
}

function LocationPin({
  cx,
  cy,
  label,
}: {
  cx: number;
  cy: number;
  label: string;
}) {
  return (
    <g>
      <path
        d={`M ${cx} ${cy + 20} L ${cx - 10} ${cy} A 14 14 0 1 1 ${cx + 10} ${cy} Z`}
        fill="#059669"
      />
      <circle cx={cx} cy={cy - 6} r={9} fill="#ffffff" />
      <text
        x={cx}
        y={cy - 2}
        textAnchor="middle"
        fontSize={11}
        fontWeight={700}
        fill="#059669"
      >
        {label}
      </text>
    </g>
  );
}
